module.exports = __webpack_public_path__ + "KaTeX_Size4-Regular.fb136838.woff2";